import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { t } from 'translation'
import history from 'utils/appHistory'

import AlarmModalAlarmItem from './AlarmModalAlarmItem'
import Spinner from 'components/ui/Spinner/Spinner'

import { setIndicationType, removeAlarm } from 'store/actions'
import { AWAKENING } from '../../utils/constants'

class AlarmModalAlarms extends Component {
  state = { isBtnAddFixed: false }

  container = React.createRef()

  controlButton = React.createRef()

  setBtnControlFixed() {
    if (!this.container.current || !this.controlButton.current) return

    const containerHeight = this.container.current.offsetHeight
    const controlButtonHeight = this.controlButton.current.offsetHeight

    if (this.state.isBtnAddFixed) {
      // Need to add control button height when button is fixed and
      // removed from height of container to prevent infinite loop
      // when difference in height is close to button height
      if (containerHeight + controlButtonHeight * 2.2 < window.innerHeight) {
        this.controlButton.current.classList.remove('fixed_mod')
        this.setState({
          isBtnAddFixed: false,
        })
      }
    } else {
      if (containerHeight >= window.innerHeight) {
        this.controlButton.current.classList.add('fixed_mod')
        this.setState({
          isBtnAddFixed: true,
        })
      }
    }
  }

  closeModalAndRemainOnGenres = () => {
    this.props.setIndicationType(AWAKENING)
    if (window.cordova)
      history.push({
        pathname: '/song-select',
        query: {
          alarm: true,
        },
      })
    else history.push('/song-select', { alarm: true })

    if (history.location.state) history.location.state.alarm = false
    this.props.closeModalHandler()
  }

  componentDidMount() {
    this.setBtnControlFixed()
  }

  componentDidUpdate() {
    this.setBtnControlFixed()
  }

  render() {
    const isLoadingData =
      this.props.isOnline && (this.props.isFetchingGenres || this.props.isFetchingSongs)
    return (
      <div className="popup alarm_mod" onClick={(e) => e.stopPropagation()}>
        <button
          className="close_btn right_pos_mod alarm_mod"
          onClick={this.props.closeModalHandler}
        ></button>
        {isLoadingData ? (
          <Spinner />
        ) : (
          <div className="popup_in" ref={this.container}>
            <div className="popup_content">
              <h2 className="section_title offset_mod alarm_mod">
                {t('alarm.SET_ALARM')}
              </h2>
            </div>
            <div className="alarm_container">
              <ul className="alarm_block_list offset_mod">
                {this.props.alarms.map(({ alarmInfo, songId }) => (
                  <AlarmModalAlarmItem
                    key={alarmInfo.id}
                    alarmInfo={alarmInfo}
                    songId={songId}
                    removeAlarmHandler={(e) => (
                      e.stopPropagation(), this.props.removeAlarm(alarmInfo.id)
                    )}
                    openEditingAlarmHandler={() =>
                      this.props.openEditingAlarmHandler(alarmInfo.id)
                    }
                  />
                ))}
              </ul>
              <div className="alarm_btn_wrap" ref={this.controlButton}>
                <button
                  className="btn_add alarm_mod"
                  onClick={this.props.openAlarmCreationHandler}
                  disabled={this.props.alarms.length >= 10 || isLoadingData}
                >
                  {t('alarm.SET_TIME')}
                </button>
                <button
                  className="btn_add alarm_mod"
                  onClick={this.closeModalAndRemainOnGenres}
                >
                  {t('alarm.PLAY_NOW')}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = ({
  auth: { isOnline },
  alarm: { alarms },
  player: { allSongs, isFetchingGenres, isFetchingSongs },
}) => ({
  allSongs,
  isFetchingGenres,
  isFetchingSongs,
  isOnline,
  alarms,
})

const willMapDispatchToProps = { setIndicationType, removeAlarm }

export default connect(mapStateToProps, willMapDispatchToProps)(AlarmModalAlarms)

AlarmModalAlarms.propTypes = {
  allSongs: PropTypes.array.isRequired,
  isFetchingGenres: PropTypes.bool.isRequired,
  alarms: PropTypes.array.isRequired,
  closeModalHandler: PropTypes.func.isRequired,
  openAlarmCreationHandler: PropTypes.func.isRequired,
  removeAlarm: PropTypes.func.isRequired,
  openEditingAlarmHandler: PropTypes.func.isRequired,
}
